'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nodeForge = require('node-forge');

var _rsa = require('../keys/rsa');

var _constants = require('./constants');

var _encoding = require('../utils/encoding');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EncryptionPublicKey = function EncryptionPublicKey(_ref) {
  var publicKey = _ref.publicKey,
      pemPublicKey = _ref.pemPublicKey,
      algo = _ref.algo;

  _classCallCheck(this, EncryptionPublicKey);

  _initialiseProps.call(this);

  if (publicKey) {
    if (!algo) throw new Error('You must specify the algo when creating from the raw key.');
    this._key = publicKey;
    this._algo = algo;
  } else {
    this.load(pemPublicKey);
  }
}

// encrypt uses symmetric encryption under the hood in order to encrypt large messages.


// encryptShort provides pure asymetric encryption but does not support messages larger than 256 bytes.
;

var _initialiseProps = function _initialiseProps() {
  var _this = this;

  this.load = function (pemPublicKey) {
    var _decodePublicKey = (0, _encoding.decodePublicKey)(pemPublicKey),
        oid = _decodePublicKey.oid,
        asn1Data = _objectWithoutProperties(_decodePublicKey, ['oid']);

    switch (oid) {
      case _constants.PKE_ALGO_RSA.oid:
        _this._key = new _rsa.RSAPublicKey(_nodeForge.pki.publicKeyFromAsn1(asn1Data.rsaPublicKey));
        _this._algo = _constants.PKE_ALGO_RSA.name;
        break;

      default:
        throw new Error('Unsupported encryption algorithm OID ' + oid + '"');
    }
  };

  this.encrypt = function (message) {
    return _this._key.encrypt(message);
  };

  this.encryptShort = function (message) {
    return _this._key.encryptShort(message);
  };

  this.export = function () {
    var asn1PublicKey = void 0;
    switch (_this._algo) {
      case _constants.PKE_ALGO_RSA.name:
        asn1PublicKey = _this._key.toAsn1();
        break;

      default:
        throw new Error('Unsupported encryption algorithm ' + _this._algo + '"');
    }

    return (0, _encoding.encodePublicKey)(asn1PublicKey, _this._algo);
  };
};

exports.default = EncryptionPublicKey;